export default __webpack_public_path__ + "static/media/img_company_header28.3bd7a77a.png";